import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject, ConnectableObservable } from 'rxjs';

import { IMember } from '../../../../app/interfaces/member';
import { OrganisationMemberApiService } from './organisation-member-api-service';

export class OrganisationMemberDataSource extends DataSource<any> {
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public errorMessage: string | null = null;
  public filter: BehaviorSubject<{
    email?: string;
    first_name?: string;
    last_name?: string;
    employee_number?: string;
  }> = new BehaviorSubject({});
  private Members: BehaviorSubject<IMember[]> = new BehaviorSubject([]);

  constructor(
    protected organisationId: number,
    protected OrganisationMemberApi: OrganisationMemberApiService
  ) {
    super();
  }

  public load() {
    this.errorMessage = null;
    this.loading.next(true);

    this.OrganisationMemberApi.list(
      'organisation-admin',
      this.organisationId,
      this.filter.value
    ).then(
      (Members: IMember[]) => {
        const filters = this.filter.value;

        if (
          filters.hasOwnProperty('email') ||
          filters.hasOwnProperty('first_name')
        ) {
          Members = Members.filter(
            (member: IMember) =>
              member.email.includes(filters.email) ||
              member.first_name.includes(filters.first_name) ||
              member.last_name.includes(filters.last_name) ||
              member.employee_number.includes(filters.employee_number)
          );
        }
        this.Members.next(Members);
        this.loading.next(false);
      },
      () => {
        this.errorMessage = "We couldn't fetch the member data. Please try again.";
        this.Members.next([]);
        this.loading.next(false);
      }
    );
  }

  public setFilter(key: string, value: string) {
    const filter = this.filter.value;

    if (value) {
      filter[key] = value;
    } else {
      filter.hasOwnProperty(key) && delete filter[key];
    }

    this.filter.next(filter);
  }

  public length() {
    return this.Members.value.length;
  }

  public connect(collectionViewer?: CollectionViewer) {
    return this.Members;
  }

  public disconnect(collectionViewer: CollectionViewer) {}
}
